import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) => ({
  modalContent: {
    padding: '20px 0'
  },

  modalDescription: {
    fontSize: theme.app.typography.label.fontSize,
    color: theme.app.colors.text.secondary,
    marginBottom: 20,
    lineHeight: 1.5
  },

  animalList: {
    maxHeight: 400,
    overflowY: 'auto',
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
    marginBottom: 20,

    '&::-webkit-scrollbar': {
      width: 6
    },

    '&::-webkit-scrollbar-track': {
      background: '#f1f1f1',
      borderRadius: 10
    },

    '&::-webkit-scrollbar-thumb': {
      background: theme.palette.primary.main,
      borderRadius: 10
    }
  },

  animalCard: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: 12,
    padding: 12,
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: 8,
    backgroundColor: theme.palette.background.default,
    transition: 'all 0.2s ease',

    '&:hover': {
      borderColor: theme.palette.primary.main,
      boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
    }
  },

  animalNumber: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',

    height: 42,
    borderRadius: '50%',
    color: theme.app.colors.text.light,
    fontSize: theme.app.typography.label.fontSize,
    fontWeight: 600,

    '& img': {
      width: 42
    }
  },

  animalInfo: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    gap: 6
  },

  animalInfoRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 6,
    fontSize: 14
  },

  animalName: {
    fontSize: 16,
    fontWeight: 600,
    color: theme.palette.primary.main
  },

  animalLabel: {
    color: theme.app.colors.text.secondary,
    fontSize: theme.app.typography.paragraph.fontSize
  },

  animalValue: {
    color: theme.app.colors.text.primary,
    fontSize: theme.app.typography.paragraph.fontSize,
    fontWeight: 500
  },

  modalActions: {
    display: 'flex',
    justifyContent: 'flex-end',
    paddingTop: 16,
    borderTop: `1px solid ${theme.palette.divider}`
  },

  closeButton: {
    padding: '10px 24px',
    border: 'none',
    borderRadius: theme.app.borderRadius.md,
    backgroundColor: theme.palette.primary.main,
    color: theme.app.colors.text.light,
    fontSize: theme.app.typography.label.fontSize,
    fontWeight: 600,
    cursor: 'pointer',
    transition: 'all 0.2s ease',

    '&:hover': {
      opacity: 0.9,
      transform: 'translateY(-1px)'
    }
  }
}))
